<div [formGroup]="form" class="gup-C-flexGroup -row -justifyBetween -alignCenter">

    <kal-form-field class="gup-C-numberRange__startMonth gup-C-flexGroup__item -demi">

        <kal-select [label]="monthStartLabel"
                    formControlName="startMonth">
            <kal-option *ngFor="let month of monthsList"
                        [value]="month.value">
                {{ month.label }}
            </kal-option>
        </kal-select>

    </kal-form-field>

    <div *ngIf="!displayMonthEnd; else displayMonthEndInputTemplate"
         class="gup-C-monthRange__link gup-C-flexGroup__item">
        <a (click)="toggleMonthEnd()"
           class="gup-O-link -secondary">
            Définir une période
        </a>
    </div>

    <ng-template #displayMonthEndInputTemplate>
        <span class="gup-C-flexGroup__item gup-C-numberRange__text">à</span>

        <kal-form-field class="gup-C-monthRange__endMonth gup-C-flexGroup__item -demi">

            <kal-select [label]="monthEndLabel"
                        formControlName="endMonth">
                <kal-option *ngFor="let month of monthsList"
                            [value]="month.value">
                    {{ month.label }}
                </kal-option>
            </kal-select>

        </kal-form-field>
    </ng-template>

</div>
